import baseApi from './baseApi';

type MessageToStore = {
  messageId?: string;
  text: string;
  role: 'assistant' | 'system' | 'user';
  AIUsage?: object;
};

const publicAccessApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    createRealtimeVoiceClient: build.mutation({
      query: (props: { companyIdentifier: string; recaptchaToken: string }) => ({
        url: '/realtimeVoice/clients',
        method: 'POST',
        body: {
          companyIdentifier: props.companyIdentifier,
          recaptchaToken: props.recaptchaToken,
        },
      }),
      transformResponse: (response: { id: string }) => response,
    }),
    startRealtimeVoiceChat: build.mutation({
      query: (props: { clientPhoneIdentifier: string }) => ({
        url: '/realtimeVoice/startChat',
        method: 'POST',
        body: { clientPhoneIdentifier: props.clientPhoneIdentifier },
      }),
      transformResponse: (response: { ephemeralToken: string }) => response,
    }),
    storeMessage: build.mutation({
      query: (props: { message: MessageToStore; clientPhoneIdentifier: string }) => ({
        url: '/realtimeVoice/storeMessage',
        method: 'POST',
        body: {
          message: props.message,
          clientPhoneIdentifier: props.clientPhoneIdentifier,
        },
      }),
    }),
    executeTool: build.mutation({
      query: (props: {
        clientPhoneIdentifier: string;
        toolCallId: string;
        functionName: string;
        functionArguments: string;
      }) => ({
        url: '/realtimeVoice/executeTool',
        method: 'POST',
        body: props,
      }),
      transformResponse: (response: { result: unknown }) => response,
    }),
  }),
  overrideExisting: false,
});

export const {
  useCreateRealtimeVoiceClientMutation,
  useStartRealtimeVoiceChatMutation,
  useStoreMessageMutation,
  useExecuteToolMutation,
} = publicAccessApi;
